<template>
  <b-tab class="border-0">
    <template #title>
      <span class="d-sm-inline-block">{{ $t('global.newData') }}</span>
    </template>

    <div v-if="!importResponse" class="card">
      <div class="card-body">
        <div class="mc-upload d-flex justify-content-between">
          <div class="mc-upload__file">
            <div class="mc-upload__file-wrapper">
              <div v-if="fileProp.name == null" class="mc-upload__file-area">
                <input
                  id="inputfile"
                  ref="inputfile"
                  type="file"
                  name="attachment"
                  class="mc-upload__file-area-input"
                  accept=".xlsx, .csv, application/wps-office.xlsx"
                  @change="fileChangeHandler"
                  @drop="fileChangeHandler"
                />

                <div class="mc-upload__file-area-text">
                  <i class="mc-fa icon-outline_upload"></i>
                  <p>{{ $t('global.importData.chooseFile') }}</p>
                  <p>{{ $t('global.importData.maksFile') }}</p>
                </div>
              </div>
              <div
                v-else
                :class="`mc-upload__file-result ${
                  fileProp.error ? 'mc-upload__file-result--error' : null
                }`"
              >
                <div class="mc-upload__file-result-wrapper">
                  <i class="mc-fa icon-outline_file"></i>
                  <h4 class="mc-upload__file-result-status">
                    {{ fileProp.message }}
                  </h4>
                  <div class="mc-upload__file-result-desc d-flex justify-content-between">
                    <span>{{ fileProp.name }}</span>
                    <span v-if="fileProp.error">
                      <i class="mc-fa icon-outline_trash-2" @click="deleteFile"></i>
                      <i class="mc-fa icon-fill_alert-triangle"></i>
                    </span>
                  </div>
                  <div class="mc-upload__file-result-progress">
                    <div :style="`width: ${fileProp.progressVal}%`"></div>
                  </div>
                  <span class="mc-upload__file-result-filesize">
                    <span>{{ fileProp.sizeProgress }} MB / </span>{{ fileProp.size }} MB
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="mc-upload__info">
            <div class="mc-upload__info-wrapper">
              <h3 class="mc-upload__info-title">
                <i class="mc-fa icon-outline_book"></i> {{ $t('global.importData.guide') }}
              </h3>
              <ul class="mc-upload__info-list">
                <li>
                  <strong> {{ $t('global.importData.downloadTemplate') }}</strong>
                  <p>
                    {{ $t('global.importData.downloadDesc') }}
                  </p>
                  <McButton
                    variant="primary"
                    size="sm"
                    icon="icon-outline_download"
                    :text="$t('global.importData.downloadTemplate')"
                    @click="downloadTemplate()"
                  />
                </li>
                <li>
                  <strong> {{ $t('global.importData.copyData') }}</strong>
                  <p>
                    {{ $t('global.importData.copyDesc') }}
                  </p>
                </li>
                <li>
                  <strong> {{ $t('global.importData.upload') }}</strong>
                  <p>
                    {{ $t('global.importData.uploadDesc1') }}
                    <b>.csv</b> atau <b>.xlsx</b>. {{ $t('global.importData.uploadDesc2') }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Result
      v-else
      :totalFailed="responseData.totalFailed"
      :totalSuccess="responseData.totalSuccess"
      :totalData="responseData.totalData"
      :errorFile="responseData.errorFile"
      :fileName="responseData.fileName"
      :fileType="responseData.fileType"
    />
  </b-tab>
</template>

<script>
import McButton from '@/components/McButton'
import { MixPanel } from '@/mixin/mixpanel'
import Result from './ImportResult'
import { IMPORT_CUT_OFF_ENGINES } from '@/services/api/setting/engineOff/engineOff'

export default {
  components: {
    McButton,
    Result,
  },
  mixins: [MixPanel],
  data() {
    return {
      importHistory: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      filteredItems: [],
      file: null,
      fileProp: {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      },
      showRemovedBtn: false,
      importResponse: false,
      responseData: {
        totalFailed: null,
        totalSuccess: null,
        totalData: null,
        errorFile: null,
        fileName: null,
        fileType: null,
      },
    }
  },
  computed: {},
  methods: {
    downloadTemplate() {
      window.open(
        'https://api-vsms-v2-bucket.s3.ap-southeast-1.amazonaws.com/templates/Template%20Tambah%20Jadwal%20Cut%20Off.xlsx',
        '_blank'
      )
    },
    async fileChangeHandler(e) {
      const files = e.target.files
      this.file = files[0]
      this.fileProp.name = files[0].name
      this.fileProp.size = (files[0].size / (1024 * 1024)).toFixed(2)

      const input = {
        filebase64: null,
        filename: files[0].name,
        importType: 'insert',
      }

      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })

      input.filebase64 = (await toBase64(files[0])).split(',')[1]

      if (
        files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
        files[0].type === 'text/csv' ||
        files[0].type === 'application/wps-office.xlsx'
      ) {
        if (this.fileProp.size > 10) {
          this.fileProp.message = this.$t('license.text.tooLarge')
          this.fileProp.error = true
          return
        }
        this.fileProp.error = false
        this.showRemovedBtn = true

        const param = [15, 25, 50, 70, 90, 100]
        for (let i = 0; i < param.length; i++) {
          setTimeout(() => {
            this.fileProp.sizeProgress = ((this.fileProp.size * param[i]) / 100).toFixed(2)
            this.fileProp.progressVal = param[i]
            if (param[i] === 100) {
              setTimeout(() => {
                this.$apollo
                  .mutate({
                    mutation: IMPORT_CUT_OFF_ENGINES,
                    variables: {
                      input: input,
                    },
                  })
                  .then((response) => {
                    if (response.data.importCutOffEngines.isSuccessful) {
                      this.importResponse = true
                      this.$emit('update:importResponse', {
                        status: true,
                        type: 'new',
                      })
                      this.responseData.totalData =
                        response.data.importCutOffEngines.importCutOffEngines.totalData
                      this.responseData.totalFailed =
                        response.data.importCutOffEngines.importCutOffEngines.totalFailed
                      this.responseData.totalSuccess =
                        response.data.importCutOffEngines.importCutOffEngines.totalSuccess
                      this.responseData.errorFile =
                        response.data.importCutOffEngines.importCutOffEngines.errorFile
                      this.responseData.fileName = files[0].name
                      this.responseData.fileType = files[0].type
                      this.track('Import Insert Engine Off Automation')
                    } else {
                      if (
                        response.data.importCutOffEngines.message == 'Error: "Incorrect File Used."'
                      ) {
                        this.fileProp.message = this.$t('license.text.template')
                        this.fileProp.error = true
                      } else {
                        return this.$mcToast.warning(response.data.importCutOffEngines.message)
                      }
                    }
                  })
              }, 1000)
            }
          }, i * 500)
        }
      } else {
        this.fileProp.message = this.$t('license.text.incompatible')
        this.fileProp.error = true
      }
    },
    deleteFile() {
      this.importResponse = false
      this.file = null
      this.fileProp = {
        name: null,
        size: 0,
        sizeProgress: 0,
        message: null,
        error: false,
        progressVal: 0,
      }
    },
  },
}
</script>
